import { HttpParams }   from '@angular/common/http';

export default class BaseSearch
{
    id          : Number        = null;
    probe       : String        = null;
    fob         : string        = null; //force order by
    
    constructor(dict  = null)
    {
      if (dict !== null)
      {
        this.id           = dict["id"] || null;
        this.probe        = dict["probe"] || null;
      }
    }
    
    buildHttpParams()
    {
      var params = new HttpParams({});
      if (this.id               !== null) { params = params.set('id', this.id.toString()); }
      if (this.probe            !== null) { params = params.set('probe', this.probe.toString()); }
      if (this.fob              !== null) { params = params.set('fob', this.fob.toString()); }
      return params;
    }
    
}
